/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    OktaConfig,
    OktaConfigFromJSON,
    OktaConfigToJSON,
} from '../models';

/**
 * 
 */
export class DamOktaApiApi extends runtime.BaseAPI {

    /**
     * Get okta config
     */
    async getOktaConfigRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<OktaConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/okta`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OktaConfigFromJSON(jsonValue));
    }

    /**
     * Get okta config
     */
    async getOktaConfig(initOverrides?: RequestInit): Promise<OktaConfig> {
        const response = await this.getOktaConfigRaw(initOverrides);
        return await response.value();
    }

}
